import {
    call,
    ForkEffect,
    put,
    StrictEffect,
    takeEvery,
    takeLatest,
} from "redux-saga/effects";
import { IFluxStandardAction } from "@store/webInterfaces";
import { getErrorCodes } from "@utils/ErrorMessageUtils";
import { MentorRepository } from "@common/domain/repositories/MentorRepository"
import { MeetingRepository } from "@common/domain/repositories/MeetingRepository"
import { ProfileRepository } from "@common/domain/repositories/ProfileRepository"
import { ProfileModel } from "@common/domain/models/Profile";
import { MeetingModel } from "@common/domain/models/Meeting";
import {
    fetchMentorListSuccess, fetchMentorListFail, IMentorPayload, IFetchLocationAction, fetchLocationFail,
    mentorActions, fetchFilteredMentorListSuccess, fetchLocationSuccess, fetchMenteesListSuccess,
    fetchMenteesListError,
    IFetchCareerBuddyAction,
    fetchCareerBuddyListSuccess,
    fetchCareerBuddyListFail,
    fetchRecommendedCareerBuddyListSuccess,
    fetchRecommendedCareerBuddyListFail,
    fetchBookSessionAgainCareerBuddyListSuccess,
    fetchBookSessionAgainCareerBuddyListFail,
    IFetchBookSessionAgainCareerBuddyAction,
    IFetchCareerBuddyPayload
} from "./actions";


export function* fetchMentorList(action: IFluxStandardAction<IMentorPayload>): Generator<StrictEffect, void, ProfileModel> {
    try {
        const response: ProfileModel = yield call(MentorRepository.fetchMentorList, action.payload);
        if (action.type === mentorActions.FETCH_FILTERED_MENTOR_LIST) {
            yield put(fetchFilteredMentorListSuccess({ res: response, type: action.payload.expertType, page: action.payload?.page }))
        } else {
            yield put(fetchMentorListSuccess({ res: response, type: action.payload.expertType, page: action.payload?.page }));
        }
    } catch (e) {
        const error = getErrorCodes(e);
        yield put(fetchMentorListFail(error));
    }
}

export function* fetchLocationSaga(action: IFetchLocationAction) {
    try {
        const result = yield call(MentorRepository.fetchLocation, action.payload);
        yield put(fetchLocationSuccess(result));
    } catch (error) {
        yield put(fetchLocationFail(error))
    }
}

export function* fetchMenteesList(action: IFluxStandardAction<string>): Generator<StrictEffect, void, ProfileModel[]> {
    try {
        const response: any = yield call(MeetingRepository.fetchMenteesList, action.payload);
        const profiles = yield call(
            ProfileRepository.fetchProfilesByUserIds,
            response
        );
        yield put(fetchMenteesListSuccess(profiles))
    } catch (e) {
        const error = getErrorCodes(e);
        yield put(fetchMenteesListError(error));
    }
}

export function* fetchCareerBuddyListSaga(action: IFetchCareerBuddyAction) {
    try {
        const response: { careerBuddy: ProfileModel[], total: number } = yield call(MentorRepository.fetchCareerBuddyList, action.payload);
        yield put(fetchCareerBuddyListSuccess({ ...response, pageNumber: action.payload?.page }))
    } catch (e) {
        const error = getErrorCodes(e);
        yield put(fetchCareerBuddyListFail(error));
    }
}


export function* fetchRecommendedcareerBuddyListSaga(action: IFetchCareerBuddyAction) {
    try {
        const response: { careerBuddy: ProfileModel[], total: number } = yield call(MentorRepository.fetchCareerBuddyList, action.payload);
        yield put(fetchRecommendedCareerBuddyListSuccess({ ...response, pageNumber: action.payload?.page }))
    } catch (e) {
        const error = getErrorCodes(e);
        yield put(fetchRecommendedCareerBuddyListFail(error));
    }
}

export function* fetchBookSessionAgainCareerBuddySaga(action: IFetchBookSessionAgainCareerBuddyAction) {
    try {
        const { userId, isSlotBooking, organizer, clientName, startDateTime, endDateTime } = action.payload;
        const payload = {
            userId,
            isSlotBooking,
            organizer,
            clientName,
            startDateTime,
            endDateTime
        }
        const response: MeetingModel[] = yield call(MeetingRepository.fetchAllMeetingList, payload);
        const organizerIds = [];
        response?.forEach(item => {
            const id = item?.getOrganizerDetail?.()?.userId;
            if (id !== undefined) {
                organizerIds.push(id);
            }
        });
        const uniqueOrganizerIds = Array.from(new Set(organizerIds));
        const careerBuddyPayload: IFetchCareerBuddyPayload = {
            ...action.payload?.careerBuddyFilter,
            userIds: uniqueOrganizerIds,
            userId: action.payload.userId
        }

        if (uniqueOrganizerIds?.length > 0) {
            const responseData: { careerBuddy: ProfileModel[], total: number } = yield call(MentorRepository.fetchCareerBuddyList, careerBuddyPayload);
            yield put(fetchBookSessionAgainCareerBuddyListSuccess({ profiles: responseData?.careerBuddy, pageNumber: 1 }))
        } else {
            yield put(fetchBookSessionAgainCareerBuddyListSuccess({ profiles: [], pageNumber: 1 }))
        }

    } catch (e) {
        const error = getErrorCodes(e);
        yield put(fetchBookSessionAgainCareerBuddyListFail(error));
    }
}

export function* watchMentor(): Generator<ForkEffect> {
    yield takeEvery(mentorActions.FETCH_MENTOR_LIST_START, fetchMentorList);
    yield takeEvery(mentorActions.FETCH_FILTERED_MENTOR_LIST, fetchMentorList);
    yield takeLatest(mentorActions.FETCH_LOCATION, fetchLocationSaga);
    yield takeLatest(mentorActions.FETCH_MENTEES_LIST_START, fetchMenteesList);
    yield takeLatest(mentorActions.FETCH_CAREER_BUDDY_LIST, fetchCareerBuddyListSaga);
    yield takeLatest(mentorActions.FETCH_RECOMMENDED_CAREER_BUDDY_LIST, fetchRecommendedcareerBuddyListSaga);
    yield takeLatest(mentorActions.FETCH_BOOKSESSIONAGAIN_CAREER_BUDDY_LIST, fetchBookSessionAgainCareerBuddySaga)
}
